import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '30px',
    marginBottom: '0.75rem',
  },
  selectorControls: {
    height: '40px',
    marginBottom: '1rem',
  },
  carousel: {
    height: '300px',
    marginBottom: '1rem',
  },
  disclaimer: {
    height: '30px',
  },
  centerElement: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};

const SkeletonFaresGridBackgroundImage = (props) => {
  const [className, style] = useStyles(props);
  const { header, selectorControls, carousel, centerElement, disclaimer } = styles;

  return (
    <Box className={`${className} fr-skeleton`} style={style} dataTestId="skeletonFaresGrid">
      <Row gutters>
        <Col xs="8">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="4">
          <Box className="fr-skeleton-element" style={selectorControls} />
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          <Box className="fr-skeleton-element" style={selectorControls} />
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          <Box className="fr-skeleton-element" style={selectorControls} />
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
              <Row gutters>
                <Col xs="6" style={centerElement}>
                  <Box className="fr-skeleton-element" style={disclaimer} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="5">
          <Box className="fr-skeleton-element" style={disclaimer} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFaresGridBackgroundImage.componentName = 'SkeletonFaresGridBackgroundImage';

export default SkeletonFaresGridBackgroundImage;
